import React from 'react';
import API from '../../../utils/API';
import InputField from '../../../components/inputs/inputField';
import SelectField from '../../../components/inputs/selectField';
import ToggleField from '../../../components/inputs/toggleField';
import FieldModal from '../../../components/modals/fieldModal';
import { withRouter } from 'react-router-dom';

class CreateFormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            formType: '',
            confirmationEmailEnabled: false,
            submitting: false,
            requiredFields: { name: false, formType: false }
        };
    }

    addForm = () => {
        const { orgId, toggle, addForm } = this.props;
        const { name, formType, confirmationEmailEnabled } = this.state;
        const requiredFields = { ...this.state.requiredFields };
        let valid = true;

        if (!name) { requiredFields.name = true; valid = false; } else { requiredFields.name = false; }
        if (!formType) { requiredFields.formType = true; valid = false; } else { requiredFields.formType = false; }

        if (!valid) {
            this.setState({ requiredFields });
            return;
        }

        this.setState({ submitting: true });
        API()
            .post(`Organizations/${orgId}/accountForms`, {
                name,
                formType: formType.value,
                confirmationEmailEnabled
            })
            .then((res) => {
                if (res.data) {
                    addForm && addForm(res.data, () => {
                        this.props.history.push(`/${orgId}/forms/${res.data._id}`);
                        toggle();
                    });
                }
            })
            .catch(() => this.setState({ submitting: false }));
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { name, formType, confirmationEmailEnabled, submitting, requiredFields } = this.state;
        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle="Create Form"
                bodyHeaderText=""
                bodyContent={() => (
                    <div>
                        <InputField
                            label="Name"
                            required={true}
                            errorTrigger={requiredFields.name}
                            value={name}
                            onChange={(e) => this.setState({ name: e.target.value })}
                        />
                        <SelectField
                            label="Form Type"
                            required={true}
                            errorTrigger={requiredFields.formType}
                            value={formType}
                            options={[
                                { value: 'programRequest', label: 'Program Request' },
                                { value: 'contactUpdate', label: 'Contact Update' }
                            ]}
                            onChange={(e) => this.setState({ formType: e })}
                        />
                        <ToggleField
                            label="Enable Confirmation Email"
                            checked={confirmationEmailEnabled}
                            icons={false}
                            onChange={(e) => this.setState({ confirmationEmailEnabled: e.target.checked })}
                        />
                    </div>
                )}
                toggle={toggle}
                actionButtonLabel={submitting ? 'Creating...' : 'Create'}
                cancelButtonLabel="Cancel"
                actionButton={this.addForm}
                submitting={submitting}
                actionButtonDisabled={submitting}
            />
        );
    }
}

export default withRouter(CreateFormModal);
